import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'procure-post-icon',
  templateUrl: './post-icon.component.html',
  styleUrl: './post-icon.component.scss',
  imports: [MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PostIcon {
  @Input() type: 'Question' | 'Poll' | 'Discussion' = 'Discussion';
  @Input() inline = false;
  @Input() clickable = true;
}
